export const PAGES = {
  HOME: "/",
  CONTACT_US: "/contact-us",
  PROFILE: "/profile",
  PROFILE_OVERVIEW: "/profile/overview",
  PROFILE_SUBSCRIPTIONS: "/profile/subscriptions",
  PROFILE_SETTINGS: "/profile/settings",
  AUTH: "/auth",
  AUTH_LOGIN: "/auth/login",
  AUTH_SIGNUP: "/auth/signup",
  AUTH_TERMS_OF_USE: "/auth/terms-of-use",
  AUTH_VERIFICATION: "/auth/verification",
  AUTH_PASSWORD_RESET: "/auth/password-reset",
  NOT_FOUND: "*"
}

export const UNPROTECTED_PAGES = [
  PAGES.AUTH,
  PAGES.AUTH_LOGIN,
  PAGES.AUTH_SIGNUP,
  PAGES.AUTH_VERIFICATION
]

export const countryOptions = [
  { value: 0, label: "Argentina", code: "AR" },
  { value: 1, label: "Austria", code: "AT" },
  { value: 2, label: "Australia", code: "AU" },
  { value: 3, label: "Belgium", code: "BE" },
  { value: 4, label: "Brazil", code: "BR" },
  { value: 5, label: "Switzerland", code: "CH" },
  { value: 6, label: "Chile", code: "CL" },
  { value: 7, label: "Colombia", code: "CO" },
  { value: 8, label: "Germany", code: "DE" },
  { value: 9, label: "Denmark", code: "DK" },
  { value: 10, label: "Spain", code: "ES" },
  { value: 11, label: "Finland", code: "FI" },
  { value: 12, label: "France", code: "FR" },
  { value: 13, label: "United Kingdom", code: "GB" },
  { value: 14, label: "Greece", code: "GR" },
  { value: 15, label: "Hong Kong", code: "HK" },
  { value: 16, label: "Indonesia", code: "ID" },
  { value: 17, label: "Republic of Ireland", code: "IE" },
  { value: 18, label: "Israel", code: "IL" },
  { value: 19, label: "India", code: "IN" },
  { value: 20, label: "Italy", code: "IT" },
  { value: 21, label: "South Korea", code: "KR" },
  { value: 22, label: "Kazakhstan", code: "KZ" },
  { value: 23, label: "Mexico", code: "MX" },
  { value: 24, label: "Malaysia", code: "MY" },
  { value: 25, label: "Netherlands", code: "NL" },
  { value: 26, label: "Norway", code: "NO" },
  { value: 27, label: "New Zealand", code: "NZ" },
  { value: 28, label: "Peru", code: "PE" },
  { value: 29, label: "Philippines", code: "PH" },
  { value: 30, label: "Russia", code: "RU" },
  { value: 31, label: "Sweden", code: "SE" },
  { value: 32, label: "Singapore", code: "SG" },
  { value: 33, label: "Thailand", code: "TH" },
  { value: 34, label: "Taiwan", code: "TW" },
  { value: 36, label: "South Africa", code: "ZA" },
  { value: 37, label: "United States", code: "US" }
]

export const gicsIndOptions = [
  { value: 101010, label: "Energy Equipment & Services" },
  { value: 101020, label: "Oil, Gas & Consumable Fuels" },
  { value: 151010, label: "Chemicals" },
  { value: 151020, label: "Construction Materials" },
  { value: 151030, label: "Containers & Packaging" },
  { value: 151040, label: "Metals & Mining" },
  { value: 151050, label: "Paper & Forest Products" },
  { value: 201010, label: "Aerospace & Defense" },
  { value: 201020, label: "Building Products" },
  { value: 201030, label: "Construction & Engineering" },
  { value: 201040, label: "Electrical Equipment" },
  { value: 201050, label: "Industrial Conglomerates" },
  { value: 201060, label: "Machinery" },
  { value: 201070, label: "Trading Companies & Distributors" },
  { value: 202010, label: "Commercial Services & Supplies" },
  { value: 202020, label: "Professional Services" },
  { value: 203010, label: "Air Freight & Logistics" },
  { value: 203020, label: "Airlines" },
  { value: 203030, label: "Marine" },
  { value: 203040, label: "Road & Rail" },
  { value: 203050, label: "Transportation Infrastructure" },
  { value: 251010, label: "Auto Components" },
  { value: 251020, label: "Automobiles" },
  { value: 252010, label: "Household Durables" },
  { value: 252020, label: "Leisure Products" },
  { value: 252030, label: "Textiles, Apparel & Luxury Goods" },
  { value: 253010, label: "Hotels, Restaurants & Leisure" },
  { value: 253020, label: "Diversified Consumer Services" },
  { value: 255010, label: "Distributors" },
  { value: 255020, label: "Internet & Direct Marketing Retail" },
  { value: 255030, label: "Multiline Retail" },
  { value: 255040, label: "Specialty Retail" },
  { value: 301010, label: "Food & Staples Retailing" },
  { value: 302010, label: "Beverages" },
  { value: 302020, label: "Food Products" },
  { value: 302030, label: "Tobacco" },
  { value: 303010, label: "Household Products" },
  { value: 303020, label: "Personal Products" },
  { value: 351010, label: "Health Care Equipment & Supplies" },
  { value: 351020, label: "Health Care Providers & Services" },
  { value: 351030, label: "Health Care Technology" },
  { value: 352010, label: "Biotechnology" },
  { value: 352020, label: "Pharmaceuticals" },
  { value: 352030, label: "Life Sciences Tools & Services" },
  { value: 451020, label: "IT Services" },
  { value: 451030, label: "Software" },
  { value: 452010, label: "Communications Equipment" },
  { value: 452020, label: "Technology Hardware, Storage & Peripherals" },
  { value: 452030, label: "Electronic Equipment, Instruments & Components" },
  { value: 453010, label: "Semiconductors & Semiconductor Equipment" },
  { value: 501010, label: "Diversified Telecommunication Services" },
  { value: 501020, label: "Wireless Telecommunication Services" },
  { value: 551010, label: "Media" },
  { value: 551020, label: "Entertainment" },
  { value: 551030, label: "Interactive Media & Services" },
  { value: 551040, label: "Water Utilities" },
  { value: 551050, label: "Independent Power and Renewable Electricity Producers" },
  { value: 601010, label: "Equity Real Estate Investment Trusts (REITs)" },
  { value: 601020, label: "Real Estate Management & Development" },
];

export const ratingEnums = {
  0: "AAA",
  1: "AA+",
  2: "AA",
  3: "AA-",
  4: "A+",
  5: "A",
  6: "A-",
  7: "BBB+",
  8: "BBB",
  9: "BBB-",
  10: "BB+",
  11: "BB",
  12: "BB-",
  13: "B+",
  14: "B",
  15: "B-",
  16: "CCC+",
  17: "CCC",
  18: "CCC-",
  19: "CC",
  20: "SD",
  21: "D"
}